<placeme-layout-seo [seo]="showcase?.seo">
  <placeme-jumbotron [seo]="showcase?.seo"></placeme-jumbotron>
  <section class="main-content">
    <div class="general">
      <article class="general__item">
        <div class="general__item__content">
          <h2 class="general__item__content__title">{{ showcase?.client?.seo?.title }}</h2>
          <p class="general__item__content__description">{{ showcase?.client?.seo?.description }}</p>
          <a class="general__item__content__link" *ngIf="showcase?.url" placeme-button target="_blank" [href]="showcase?.url">Voir</a>
        </div>
        <div class="general__item__illustration">
          <img [src]="showcase?.client?.seo?.image?.url" [alt]="showcase?.client?.seo?.title" [title]="showcase?.client?.seo?.title" />
        </div>
      </article>
    </div>
  </section>
  <section class="main-content">
    <markdown class="page-markdown" [data]="'showcasePage.project' | translate"></markdown>
    <article class="projet">
      <markdown [data]="showcase?.content"></markdown>
    </article>
  </section>
  <section class="main-content">
    <markdown class="page-markdown offer-markdown" [data]="'showcasePage.offer' | translate: showcase"></markdown>
    <placeme-offer-card class="offer-card" *ngIf="showcase?.offer" [offer]="showcase?.offer"></placeme-offer-card>
  </section>
  <section class="main-content">
    <markdown class="page-markdown" [data]="'showcasePage.images' | translate"></markdown>
    <div class="photos">
      <img
        class="photos__item"
        *ngFor="let photo of album; let i = index"
        (click)="open(i)"
        [src]="photo?.src"
        [alt]="photo?.caption"
        [title]="photo?.caption"
      />
    </div>
  </section>
</placeme-layout-seo>
